import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatDividerModule } from "@angular/material/divider";

import { combineLatest } from "rxjs";
import { HierarchyCacheService } from "src/modules/shared/services/hierarchy-cache.service";
import { UserStateService } from "src/shared/services/user-state.service";

import { LibraryNavigationService } from "../../services/library-navigation.service";
import { LibraryNavigationNodeComponent } from "../library-navigation-node/library-navigation-node.component";

@Component({
  selector: "app-library-navigation",
  templateUrl: "./library-navigation.component.html",
  styleUrls: ["./library-navigation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LibraryNavigationNodeComponent, AsyncPipe, MatDividerModule],
})
export class LibraryNavigationComponent {
  private readonly cacheService = inject(HierarchyCacheService);
  private readonly userStateService = inject(UserStateService);
  private readonly libraryNavigationService = inject(LibraryNavigationService);

  //

  readonly vm$ = combineLatest({
    root: this.cacheService.getNavigationRoot(),
    isEditor: this.userStateService.isEditor$,
    pathInfo: this.libraryNavigationService.pathInfo$,
  });
}
